module.exports = __webpack_public_path__ + "img/5af8a073a9d037fa2da4563ac201333.dc951894.png";